<template>
  <v-app>
    <!-- <v-main class="page"> -->
    <v-main :style="styleObject">
      <v-container fluid fill-height>

        <v-row class="d-flex flex-row"  justify="center" style="align-items: center;">
          <div class="login-card">
            <div class="login-header">
              <img src="img/Frazier.png" height="50px" />
              <!-- <v-img src="img/Frazier.png" contain width="200" /> -->
              <div style="display: flex; align-items: center;">
                <h2 class="d-none d-sm-flex" style="
                    white-space: nowrap;
                    font-variant: small-caps;
                    text-align: right;
                    font-weight: 450;
                  ">
                  Customer Portal Login
                </h2>
              </div>
            </div>
            <div class="login-body">
              <div class="login-text">
                <div style="display: none; justify-content: center; margin-top: 15px; text-align: center; margin-right: 40px;">
                  <my-video :videoWidth="960" :videoHeight="540" video-file="Frazier_Portal_Video.mp4" frame-file="Frazier_Portal_Video_Moment_Grayscale_txt.png" title="Frazier Customer Portal" :autoplay="true">
                    <template #description>
                      <div style="font-size: .9em; font-weight: 500; color: #006bb7; text-transform: uppercase; text-align: center; letter-spacing: 0.015em">Click to see the tremendous value <br />Frazier's Customer Portal provides !</div>
                    </template>
                  </my-video>
                </div>
                <div style="display: flex; flex-flow: column nowrap; justify-content: space-around">
                  <v-form v-model="valid" ref="form" lazy-validation class="login-form">
                    <v-text-field class="my-1" label="Email Address" @keyup.enter.native="login" v-model="email" :rules="rules.email" validate-on-blur prepend-icon="fa-user" required clearable></v-text-field>
                    <v-text-field class="my-1" label="Password" @keyup.enter.native="login" :type="hidePassword ? 'password' : 'text'" :rules="rules.required" validate-on-blur v-model="password" prepend-icon="fas fa-shield" :append-outer-icon="`fal fa-eye${hidePassword ? '-slash' : ''}`" @click:append-outer="hidePassword = !hidePassword" required counter clearable></v-text-field>
                  </v-form>
                  <div style="border-top: 1px solid lightgray; padding-top: 10px;">
                    <v-btn color="primary" block dense @click="login" :disabled="!valid" :loading="loading">login</v-btn>
                    <div style="display: flex; justify-content: space-between;margin-top: 15px;">
                      <v-btn text small color="primary" :to="{ path: 'photogallery' }">Photo Gallery</v-btn>
                      <v-btn text small color="primary" :to="{ name: 'ForgotPassword' }">Forgot Password ?</v-btn>
                    </div>
                  </div>
                  <!-- <v-row class="pa-3 my-3" justify="end">
                  </v-row> -->
                </div>
              </div>
              <div id="welcomevideo" class="d-flex align-center justify-center ml-8 mt-4">
                <MyVideo ref="userGuide" :videoFile="helpVideo.VideoFile" :frameFile="helpVideo.VideoImage" :title="helpVideo.Title"></MyVideo>
              </div>
            </div>
            <div class="error-response" v-html="errorMsg" v-if="errorMsg.length > 0" />
          </div>
        </v-row>
      </v-container>
      <loading :show="loading" label="Please Wait"></loading>
    </v-main>
  </v-app>
</template>

<script>
import axios from 'axios'
import Loading from '@/components/Loading'
import { rules } from '@/functions'
import MyVideo from '@/components/Video'
// import { GetLocalStorage } from '@/storage'

export default {
  name: 'LoginPage',
  components: {
    Loading,
    MyVideo
  },
  data() {
    return {
      // debug: false,
      rules,
      hidePassword: true,
      valid: true,
      email: '',
      password: '',
      errorMsg: '',
      loading: false,
      language: 'en',
      helpVideo: {
        VideoFile: 'Frazier_Customer_Portal.mp4',
        VideoImage: 'Frazier_Customer_Portal.jpg',
        Title: 'Frazier Customer Portal User Guide',
        Description: ''
      }
    }
  },
  computed: {
    styleObject: function() {
      // var backgroundImageID = (Math.floor(Math.random() * 12) + 1)
      return {
        backgroundImage: 'url(img/Customer_Portal_Login_Screen_Image.png)',
        backgroundSize: 'cover',
        backgroundPosition: 'bottom',
        backgroundAttachment: 'fixed'
      }
    },
    locale() {
      return this.$i18n.locale()
    }
  },
  created() {
    document.title = process.env.VUE_APP_TITLE
    // this.debug = process.env.VUE_APP_MODE !== 'production'
  },
  // mounted() {
  //   if (GetLocalStorage()) {

  //   }
  // }
  methods: {
    testSecured() {
      axios.get('security/testsecured')
    },
    clear() {
      this.$refs.form.reset()
    },
    login() {
      if (this.$refs.form.validate()) {
        this.loading = true
        axios
          .post('security/RequestToken', {
            Email: this.email,
            Password: this.password
          })
          .then(response => {
            this.loading = false
            this.errorMsg = ''
            this.$store.commit('user/setUser', { token: response.data.token, userId: response.data.UserID, userRole: response.data.userRole, fullAccess: response.data.hasFullAccess })
            this.$store.commit('user/requirePass', response.data.userPass)
            this.$router.push({ name: 'Home' })
          })
          .catch(error => {
            this.errorMsg = error.response === undefined ? 'An unknown error occurred.' : error.response.data
            this.loading = false
          })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  background: 'url(img/Customer_Portal_Login_Screen_Image.jpg) no-repeat center fixed';
}

.login-card {
  background-color: white;
  min-width: 750px;
  border-radius: 5px;
  padding: 20px;
}

.login-body {
  display: flex;
  flex-flow: row nowrap;
  gap: 20px;
  align-items: center;
}

.login-header {
  border-bottom: 1px solid lightgray;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  // padding: 20px 0px 10px 0px;
  padding-bottom: 10px;
}

.login-text {
  display: flex;
  flex-flow: row nowrap;
  // justify-content: flex-end;
  justify-content: center;
  // padding: 10px;
  // text-align: center;
}

.login-form {
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  // align-items: stretch;
  min-width: 450px;
  // flex: 1 1 auto;
}

.error-response {
  text-align: center;
  color: red;
  font-weight: 450;
  font-size: 1.2em;
  padding-top: 10px;
  border-top: 1px solid lightgray;
}

</style>
